import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { useIntl } from 'react-intl';
import { Button } from '@luigiclaudio/ga-baseline-ui/button';
import ColorModalCloseButtonContainer from './ColorModalCloseButtonContainer';

const ColorModalCloseButton = ({ onRequestClose }) => {
    const intl = useIntl();
    const theme = useContext(ThemeContext);

    return (
        <ColorModalCloseButtonContainer>
            <Button
                btnType="link"
                onClick={() => onRequestClose()}
                aria-label={intl.formatMessage({ id: 'modal.close.label' })}
                icon={theme.modal.closeIcon.icon}
                iconSize={theme.modal.closeIcon.size}
                iconColor={theme.base.grays.grayLight}
                size="sm"
            />
        </ColorModalCloseButtonContainer>
    );
};

ColorModalCloseButton.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
};

export default ColorModalCloseButton;
